import mixins from "../../mixins";

const generateUID = mixins.generateUID.methods.generateUID;

export default {
  isEditMode: true,
  pageProperties: {
    "pages": [
      {
        "pageName": "home",
        "pageId": 1,
        "sections": [
          {
            "sectionId": "a0us1n",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "fields": [
              {
                fieldId: "vas2fp",
                fieldType: "multi-campaign"
              }
            ]
          }
        ]
      },
      { // Elmex-MB2023 campaign
        "pageName": "Elmex-MB2023",
        "pageId": 28972,
        "isPublic": true,
        "sections": [
          {
            "sectionId": "orbg8s",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "fields": [
              {
                "fieldType": "refresh-token",
                "fieldId": "ij3433"
              },
              {
                fieldId: "dte-003",
                fieldType: "dataLayer-event",
                properties: {
                  eventName: "PageView",
                  fbEvent: "PageView"
                }
              },
              {
                "fieldType": "key-visual",
                "fieldId": "296eg1",
                "properties": {
                  "grid": {
                    "columns": "12"
                  },
                  "styles": {
                    "margin": '2% 0 0 0',
                    "padding": '0'
                  },
                  "imageStyles":{
                    'border-radius': '16px'
                  },
                  "noContainer": false,
                  "addRow": true,
                  "desktopImageUrl": "/assets/campaigns/Elmex-MB2023/key-visual.png",
                  "mobileImageUrl": "/assets/campaigns/Elmex-MB2023/key-visual.png"
                }
              },
              {
                "fieldType": "participa",
                "fieldId": "acsh315",
                "properties": {
                  "grid": {
                    "columns": "12"
                  },
                  "color": "#0A8870",
                  "buttonClass": "btn-elmex-green-gradient",
                  "nextPage": "Elmex-MB2023/InscrieBonul",
                  "campaign": "Elmex-MB2023",
                  "borderColor":"rgba(10, 136, 112, 0.25)",
                  "steps": [
                    {
                      "title": "Pasul 1",
                      "text": "Cumpara produse Elmex Sensitive.",
                      "image": "select"
                    },
                    {
                      "title": "Pasul 2",
                      "text": "Incarca bonul fiscal",
                      "image": "receipt"
                    },
                    {
                      "title": "Pasul 3",
                      "text": "Inregistreaza-te",
                      "image": "register"
                    },
                    {
                      "title": "Pasul 4",
                      "text": "Primești banii înapoi!",
                      "image": "reward"
                    }
                  ]
                }
              }
            ]
          }
        ]
      },
      { // Upload receipt
        "pageName": "Elmex-MB2023/InscrieBonul",
        "pageId": 22345,
        "sections": [
          {
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "sectionId": "fu30zq",
            "fields": [
              {
                "fieldType": "step-counter",
                "fieldId": "tj4j49",
                "properties": {
                  "activeIndex": 1,
                  "colorSchema": "#00B098",
                  "stepShadow": "#B2D8D1",
                  "startGradient": "#B2D8D1",
                  "endGradient": "#00B098",
                  "completedGradient": "linear-gradient(265.59deg, #1E8870 -19.85%, #00B098 100%), #ffffff",
                  "steps": [
                    {
                      "title": "Cumpara Elmex Sensitive",
                      "page": "Cumpără Ajax si/sau Axion"
                    },
                    {
                      "title": "Incarca bonul fiscal",
                      "page": "Elmex-MB2023/Inregistreaza"
                    },
                    {
                      "title": "Inregistreaza-te",
                      "page": "Elmex-MB2023/Inregistreaza"
                    },
                    {
                      "title": "Castiga premii!",
                      "page": "Elmex-MB2023/Inregistreaza"
                    }
                  ]
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "<h1>Incarca bonul fiscal/factura</h1>",
                  styles: {
                    "font-family": 'Plus Jakarta Sans;',
                    "color": "#0E1B17"
                  }
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "La acest pas, te rugam sa incarci dovada achizitionarii produselor Elmex Sensitive.",
                  "grid": {
                    "marginTop": "15px",
                    "marginBottom": "30px"
                  },
                  styles: {
                    "font-weight": '500;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '20px;',
                    "color": "#00291C"
                  }
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "basg325",
                "properties": {
                  "text": "Te rugam sa faci o poza a intregului/intregii bon fiscal/facturi sau sa incarci un PDF al bonului fiscal/facturii",
                  "grid": {
                    "marginBottom": "40px"
                  },
                  styles: {
                    "font-weight": '400;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '14px;',
                    "line-height": "20px;",
                    "color": "#00291C"
                  }
                }
              }
            ]
          },
          {
            "sectionId": "dyx8uv",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 0,
                    "justifyContent": "center",
                    "maxWidth": "1230px"
                  },
                  "fields": [
                    {
                      "fieldType": "receipt-processor",
                      "fieldId": "klvakj",
                      "properties": {
                        texts: {
                          choose: 'Selecteaza un fisier',
                          receiptUpload: '<span style="font-size:18px; font-weight: 500;font-family:Plus Jakarta Sans">Apasa aici pentru a incarca bonul fiscal/factura.</span>.<br> Doar fisierele JPEG, PNG si PDF sunt acceptate.<br> Maxim 16 MB.',
                          wrongFormat: 'Acest format nu este suportat. Doar fisiere jpeg, png sau pdf sunt acceptate.',
                          fileSizeLimit: 'Fisierul este prea mare. Acesta nu poate avea mai mult de 16 MB.'
                        },
                        "colorSchema": "#00B098",
                        "fileUploadColor": "rgba(0, 0, 0, 0.5)",
                        "borderColor": "#0A8870",
                        "buttonClass": "btn-elmex-green-secondary",
                        "inputBacgroundColor":"#E9F3F1",
                        "grid": {
                          "columns": 5,
                          "alignItems": "center",
                          "justifyContent": "center"
                        },
                        "successAction": {
                          "fn": "goToPage",
                          "params": "Elmex-MB2023/Inregistreaza"
                        },
                        "campaignId": "elmex-moneyback-2023",
                        "phrases": [
                          "Chitanta dvs. este acum incarcata si procesata.",
                          "Chitanta va fi procesata automat. Aceasta poate dura un minut. Va rugam sa aveti rabdare.",
                          "Daca primiti un mesaj de eroare, luati o versiune mai buna a chitantei si incarcati-o din nou."
                        ],
                        "cornerDetectionPhrases": [
                          "Te rugam sa ajustezi dreptunghiul gri pentru a incadra bonul.",
                          "Te rugam sa potrivesti bonul in cadran.",
                          "Puteti sterge informatii private cu instrumentul de stergere."
                        ],
                        "eraseColor": "#ffffff",
                        "eraseSize": 12,
                        "cropColor": "#F27B26",
                        "cropBackground": "rgba(0,0,0,0.6)",
                        "cropTitle": "Decupeaza",
                        "eraseTitle": "Acopera",
                        "dragTitle": "Deplaseaza imaginea",
                        "zoomInTitle": "Mareste",
                        "zoomOutTitle": "Micsoreaza",
                        "selectImageTitle": "Select an Image",
                        "selectAnotherTitle": "Select Another",
                        "controlsBackground": "#6B3050",
                        "backgroundColorBtn": "black",
                        "textColor": "#141414"
                      }
                    },
                    {
                      "fieldType": "empty-bucket",
                      "properties": {
                        "grid": {
                          "columns": 7
                        },
                        "fields": [
                          {
                            "fieldType": "receipt-information",
                            "fieldId": "5mq1p6",
                            "properties": {
                              "grid": {
                                "alignItems": "center",
                                "justifyContent": "center",
                                "columns": "12"
                              },
                              "styles": {
                                "text-align": "left"
                              },
                              "color": "#6B3050",
                              "textColor": "#0E1B17",
                              "descriptionTextColor":"#00291C",
                              "descriptionText": "Nu se accepta bonuri sau facturi pliate/indoite sau scanate",
                              "receiptImage": "receipt28",
                              "steps": [
                                {
                                  "text": "Nume Retailer/ Magazin",
                                  "label": "A"
                                },
                                {
                                  "text": "Produsele care intra in promotie si pretul lor",
                                  "label": "B"
                                },
                                {
                                  "text": "Suma totala a bonului/facturii in LEI/RON",
                                  "label": "C"
                                },
                                {
                                  "text": "Data si ora de pe bon sau de pe factura",
                                  "label": "D"
                                },
                                {
                                  "text": "Nr bonului fiscal/facturii",
                                  "label": "E"
                                }
                              ]
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            "sectionId": "bsbsd35",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "receipt-image-information"
              }
            ]
          },
          {
            "sectionId": "hmgwhl",
            "grid": {
              "columns": 12,
              "display": "flex",
              "alignItems": "center",
              "position": "relative",
              "paddingTop": "60px",
              "paddingBottom": "40px"
            },
            "container": true,
            "buttonsWrap": true,
            "fields": [
              {
                "fieldType": "button-component",
                "fieldId": "16tzm1",
                "properties": {
                  "grid": {
                    "columns": "0"
                  },
                  "addClass": "btn-link",
                  "text": "Inapoi",
                  "disabled": false,
                  "styles": {
                    "position": "absolute;",
                    "left": 0
                  },
                  "action": {
                    "fn": "goToPage",
                    "params": "Elmex-MB2023"
                  }
                }
              },
              {
                "fieldType": "button-component",
                "fieldId": "16tzm2",
                "properties": {
                  "grid": {
                    "columns": "0",
                    "alignItems": "center",
                    "justifyContent": "center"
                  },
                  "text": "Continua",
                  "addClass": "btn-elmex-green-gradient",
                  "shouldCheckCrop": true,
                  "requires": ["klvakj"],
                  "action": {
                    "fn": "sendReceipt",
                    "params": ""
                  }
                }
              }
            ]
          }
        ]
      },
      { // Register form
        "pageName": "Elmex-MB2023/Inregistreaza",
        "pageId": 634553232,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 12
            },
            "container": true,
            "fields": [
              {
                "fieldType": "step-counter",
                "fieldId": "tj4j49",
                "properties": {
                  "activeIndex": 2,
                  "colorSchema": "#00B098",
                  "stepShadow": "#B2D8D1",
                  "startGradient": "#B2D8D1",
                  "endGradient": "#00B098",
                  "completedGradient": "linear-gradient(265.59deg, #1E8870 -19.85%, #00B098 100%), #ffffff",
                  "steps": [
                    {
                      "title": "Cumpara Elmex Sensitive",
                      "page": "Cumpără Ajax si/sau Axion"
                    },
                    {
                      "title": "Incarca bonul fiscal",
                      "page": "Elmex-MB2023/Inregistreaza"
                    },
                    {
                      "title": "Inregistreaza-te",
                      "page": "Elmex-MB2023/Inregistreaza"
                    },
                    {
                      "title": "Castiga premii!",
                      "page": "Elmex-MB2023/Inregistreaza"
                    }
                  ]
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "fckzg7",
                "properties": {
                  "text": "<h1>Formular de inscriere</h1>",
                  styles:{
                      "color":"#0E1B17"
                  }
                }
              }
            ]
          },
          {
            "sectionId": "ci88zt",
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 4,
              "marginTop": "40px"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "form-component",
                "fieldId": "j765n4b",
                "properties": {
                  "styles": {
                    "margin": "0",
                    "justifyContent": "center",
                    "--maxWidth": "545px",
                    "--backgroundColor": "#E9F3F1"
                  },
                  "grid": {
                    "alignItems": "center",
                    "columns": "0",
                    "justifyContent": "center"
                  },
                  "requires": [
                    "1"
                  ],
                  "successAction": {
                    "fn": "goToPage",
                    "params": "Elmex-MB2023/Multumim"
                  },
                  "endpoint": "/register",
                  "ibanEndpoint": "/submitIBANv2",
                  "fields": [
                    {
                      "fieldId": "b4baqs",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "surname",
                        "autocomplete": "no",
                        "label": "Prenume",
                        "placeholder": "",
                        "text": "",
                        "color": "#0E1B17",
                        "validation": "required|onlyLetters",
                        "grid": {
                          "alignItems": "center",
                          "justifyContent": "center",
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "30px",
                          "border-color": "#ADB5BD"
                        }
                      }
                    },
                    {
                      "fieldId": "gofije",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "name",
                        "autocomplete": "no",
                        "label": "Nume",
                        "placeholder": "",
                        "text": "",
                        "color": "#0E1B17",
                        "validation": "required|onlyLetters",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#ADB5BD"
                        }
                      }
                    },
                    {
                      "fieldId": "h7kzf9",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "email",
                        "label": "E-mail",
                        "placeholder": "",
                        "text": "",
                        "color": "#0E1B17",
                        "validation": "required|email",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#ADB5BD"
                        }
                      }
                    },
                    {
                      "fieldId": "vake42c",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "mobile",
                        "label": "Numar de telefon",
                        "placeholder": "",
                        "text": "",
                        "color": "#0E1B17",
                        "validation": "required|phoneNumber",
                        "grid": {
                          "columns": 12
                        },
                        "autocomplete": "nope",
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#ADB5BD"
                        }
                      }
                    },
                    {
                      "fieldId": "vake43c",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "iban",
                        "label": "IBAN",
                        "placeholder": "",
                        "mask": "RO## AAAA NNNN NNNN NNNN NNNN",
                        "upperCase": true,
                        "text": "",
                        "color": "#0E1B17",
                        "validation": "required|iban",
                        "grid": {
                          "columns": 12
                        },
                        "autocomplete": "nope",
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#ADB5BD"
                        }
                      }
                    },
                    { 
                      "fieldId": "v1nf34",
                      "fieldType": "select-input",
                      "properties": {
                        "name": "bank",
                        "label": "Bancă",
                        "placeholder": "Bancă",
                        "text": "",
                        "validation": "required",
                        "options": [
                          { "text": "Alpha Bank", "value": "BUCU" },
                          { "text": 'Banca Romaneasca', "value": 'BRMA' },
                          { "text": 'Banca Transilvania', "value": 'BTRL' },
                          { "text": 'BCR', "value": 'RNCB' },
                          { "text": 'BRCI', "value": 'MIND' },
                          { "text": 'BRD', "value": 'BRDE' },
                          { "text": 'CEC', "value": 'CECE' },
                          { "text": 'Credit Agricole', "value": 'BSEA' },
                          { "text": 'Credit Europe Bank', "value": 'FNNB' },
                          { "text": 'Eximbank', "value": 'EXIM' },
                          { "text": 'FirstBank', "value": 'PIRB' },
                          { "text": 'Garanti Bank', "value": "UGBI" },
                          { "text": 'Idea Bank', "value": 'ROIN' },
                          { "text": 'ING', "value": 'INGB' },
                          { "text": 'Intesa Sanpaolo Bank', "value": 'WBAN' },
                          { "text": 'Libra Bank', "value": 'BREL' },
                          { "text": 'Orange Money', "value": 'ORMF' },
                          { "text": 'OTP Bank', "value": 'OTPV' },
                          { "text": 'Patria Bank', "value": 'CARP' },
                          { "text": 'ProCredit Bank', "value": 'MIRO' },
                          { "text": 'Raiffeisen Bank', "value": 'RZBR' },
                          { "text": 'TBI Bank', "value": 'TBIB' },
                          { "text": 'UniCredit Tiriac Bank', "value": 'BACX' },
                          { "text": 'Vista Bank', "value": 'EGNA' },
                          { "text": "Altele", "value": "AAAA" }
                        ],
                        "selectedValue": "",
                        "grid": {
                          "columns": "12"
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#ADB5BD !important"
                        }
                      }
                    },
                    {
                      "fieldId": "gofij1",
                      "fieldType": "text-area",
                      "properties": {
                        "name": "returnReason",
                        "autocomplete": "no",
                        "label": "Introdu motivul",
                        "placeholder": "",
                        "text": "",
                        "color": "#0E1B17",
                        "validation": "required|min:20|max:200",
                        "maxlength": 201,
                        "grid": {
                          "alignItems": "center",
                          "justifyContent": "center",
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#ADB5BD"
                        }
                      }
                    },
                    {
                      "fieldId": "ko3h1sz",
                      "fieldType": "paragraph",
                      "properties": {
                        "text": "<b>Atentie!</b> In cazul introducerii unei adrese de e-mail gresite, daca esti declarat castigator, nu vei primi premiul castigat, conform Articolelor 4.3, 4.4, 8.7 si 8.8 din Regulamentul campaniei.",
                        "grid": {
                          "columns": "12",
                          "marginTop": "35px"
                        },
                        "classes": ['disclaimer'],
                        "styles":{
                          "color": "#00291C !important"
                        }
                      }
                    },
                    {
                      "fieldId": "wgc3j7",
                      "fieldType": "checkbox",
                      "properties": {
                        "name": "terms",
                        "validation": {
                          "required": {
                            "allowFalse": false
                          }
                        },
                        "validationName": "Termenii si conditiile sunt necesare",
                        "grid": {
                          "columns": "12",
                          "paddingTop": "10px"
                        },
                        "styles": {
                          "margin-top": "30px",
                          "--color": "#00291C",
                          "--checkedCheckbox": "url(/assets/icons/form/checked_checkbox.svg)",
                          "--uncheckedCheckbox": "url(/assets/icons/form/unchecked_checkbox.svg)"
                        },
                        "label": `Confirm ca am peste 18 ani. Confirm <a href="/files/Elmex-MB2023Regulament.pdf" target="_blank"><u>termenii si conditiile</u></a> si <a href="https://www.colgatepalmolive.ro/legal-privacy-policy/privacy-policy" target="_blank"><u>politica de confidentialitate</u></a></div>.`
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            "sectionId": "yh453gg4",
            "grid": {
              "columns": 12,
              "display": "flex",
              "alignItems": "center",
              "position": "relative",
              "paddingTop": "60px",
              "paddingBottom": "120px"
            },
            "container": true,
            "buttonsWrap": true,
            "fields": [
              {
                "fieldType": "button-component",
                "fieldId": "16tzm1",
                "properties": {
                  "grid": {
                    "columns": "0"
                  },
                  "addClass": "btn-link",
                  "text": "Inapoi",
                  "disabled": false,
                  "styles": {
                    "position": "absolute;",
                    "left": 0
                  },
                  "action": {
                    "fn": "goToPage",
                    "params": "Elmex-MB2023/InscrieBonul"
                  }
                }
              },
              {
                "fieldType": "button-component",
                "fieldId": "16tzm2",
                "properties": {
                  "grid": {
                    "columns": "0",
                    "alignItems": "center",
                    "justifyContent": "center"
                  },
                  "text": "TRIMITE",
                  "disabled": false,
                  "addClass": "btn-elmex-green-gradient",
                  "action": {
                    "fn": "sendForm",
                    "params": "j765n4b"
                  }
                }
              }
            ]
          }
        ]
      },
      { // Winner form page
        "pageName": "Elmex-MB2023/WinnerPage",
        "isPublic": true,
        "pageId": 634553,
        "sections": [
          {
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "headerWrap": true,
            "sectionId": "basb782",
            "fields": [
              {
                "fieldType": "query-string-to-state",
                "fieldId": "vasv24",
                properties: {
                  variables: [
                    {
                      query: "customerToken",
                      state: "customerToken"
                    }
                  ]
                }
              },
              {
                "fieldType": "query-string-to-state",
                "fieldId": "uwxo2o1",
                properties: {
                  variables: [
                    {
                      query: "receiptToken",
                      state: "receiptToken"
                    }
                  ]
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "<h1 style=' color= #0E1B17; '>Formular pentru Castigator</h1>"
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "Completeaza-ti adresa in formularul de mai jos pentru a-ti putea trimite premiul",
                  "grid": {
                    "marginTop": "15px",
                    "marginBottom": "30px"
                  },
                  styles: {
                    "font-weight": '500;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '20px;',
                    "color": "#00291C"
                  }
                }
              }
            ]
          },
          {
            "sectionId": "ci88zt",
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 4,
              "marginTop": "50px"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "form-component",
                "fieldId": "j765n4b",
                "properties": {
                  "styles": {
                    "margin": "0",
                    "justifyContent": "center",
                    "--backgroundColor": "#E9F3F1"
                  },
                  "grid": {
                    "alignItems": "center",
                    "columns": "0",
                    "justifyContent": "center"
                  },
                  "requires": [
                    "1"
                  ],
                  "successAction": {
                    "fn": "goToPage",
                    "params": "Elmex-MB2023/WinnerThankYou"
                  },
                  "endpoint": "/winnerRegister",
                  "fields": [
                    {
                      "fieldId": "b4baqs",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "surname",
                        "autocomplete": "no",
                        "label": "Prenume",
                        "placeholder": "",
                        "text": "",
                        "color": "#0E1B17",
                        "validation": "required|onlyLetters",
                        "grid": {
                          "alignItems": "center",
                          "justifyContent": "center",
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "30px",
                          "border-color": "#ADB5BD"
                        }
                      }
                    },
                    {
                      "fieldId": "gofije",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "name",
                        "autocomplete": "no",
                        "label": "Nume",
                        "placeholder": "",
                        "text": "",
                        "color": "#0E1B17",
                        "validation": "required|onlyLetters",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#ADB5BD"
                        }
                      }
                    },
                    {
                      "fieldId": "h7kzf9",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "email",
                        "label": "E-mail",
                        "placeholder": "",
                        "text": "",
                        "color": "#0E1B17",
                        "validation": "required|email",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#ADB5BD"
                        }
                      }
                    },
                    {
                      "fieldId": "vake42c",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "mobile",
                        "label": "Numar de telefon",
                        "placeholder": "",
                        "text": "",
                        "color": "#0E1B17",
                        "validation": "required|phoneNumber",
                        "grid": {
                          "columns": 12
                        },
                        "autocomplete": "nope",
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#ADB5BD"
                        }
                      }
                    },
                    {
                      "fieldId": "h7kzf8",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "address",
                        "label": "Adresa",
                        "placeholder": "",
                        "text": "",
                        "color": "#0E1B17",
                        "validation": "requiredAdress|adress",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#ADB5BD"
                        }
                      }
                    },
                    {
                      "fieldId": "ko3h1sz",
                      "fieldType": "paragraph",
                      "properties": {
                        "text": "*strada, numar, bloc, scara, apartament",
                        "grid": {
                          "columns": "12",
                          "marginTop": "20px;",
                          "marginBottom": "20px"
                        },
                        "classes": ['disclaimer'],
                        "styles":{
                          "color": "#00291C !important"
                        }
                      }
                    }
                  ],
                  "extraFields": [
                    {
                      "fieldId": "bdsb632",
                      "fieldType": "select-input-county",
                      "properties": {
                        "name": "judet",
                        "label": "Judet",
                        "placeholder": "Judet",
                        "text": "",
                        "color": "#0E1B17",
                        "validation": "requiredJudet",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "30px",
                          "border-color": "#ADB5BD"
                        },
                        "autocomplete": "nope"
                      }
                    },
                    {
                      "fieldId": "bask257",
                      "fieldType": "select-input-city",
                      "properties": {
                        "name": "localitate",
                        "label": "Localitate",
                        "placeholder": "Localitate",
                        "text": "",
                        "color": "#0E1B17",
                        "validation": "requiredLocal",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#ADB5BD"
                        },
                        "autocomplete": "nope"
                      }
                    },
                    {
                      "fieldId": "acasg235",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "postal",
                        "label": "Cod postal",
                        "placeholder": "",
                        "text": "",
                        "color": "#0E1B17",
                        "validation": "integer|length:6",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#ADB5BD"
                        },
                        "autocomplete": "nope",
                        "disablePaste": true
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            "sectionId": "yh453gg4",
            "grid": {
              "columns": 12,
              "display": "flex",
              "alignItems": "center",
              "position": "relative",
              "paddingTop": "60px",
              "paddingBottom": "130px"
            },
            "container": true,
            "styles": {
              'justify-content': 'center'
            },
            "fields": [
              {
                "fieldType": "button-component",
                "fieldId": "16tzm2",
                "properties": {
                  "grid": {
                    "columns": "0",
                    "alignItems": "center",
                    "justifyContent": "center"
                  },
                  "text": "TRIMITE",
                  "disabled": false,
                  "addClass": "btn-elmex-green-gradient",
                  "action": {
                    "fn": "sendForm",
                    "params": "j765n4b"
                  }
                }
              }
            ]
          }
        ]
      },
      { // Winner CNP form page
        "pageName": "Elmex-MB2023/WinnerPageCNP",
        "isPublic": true,
        "pageId": 6345531,
        "sections": [
          {
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "headerWrap": true,
            "sectionId": "basb782",
            "fields": [
              {
                "fieldType": "query-string-to-state",
                "fieldId": "vasv24",
                properties: {
                  variables: [
                    {
                      query: "customerToken",
                      state: "customerToken"
                    }
                  ]
                }
              },
              {
                "fieldType": "query-string-to-state",
                "fieldId": "uwxo2o1",
                properties: {
                  variables: [
                    {
                      query: "receiptToken",
                      state: "receiptToken"
                    }
                  ]
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "<h1 style=' color= #0E1B17; '>Formular pentru Castigator</h1>"
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "Completeaza-ti adresa in formularul de mai jos pentru a-ti putea trimite premiul",
                  "grid": {
                    "marginTop": "15px",
                    "marginBottom": "30px"
                  },
                  styles: {
                    "font-weight": '500;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '20px;',
                    "color": "#00291C"
                  }
                }
              }
            ]
          },
          {
            "sectionId": "ci88zt",
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 4,
              "marginTop": "50px"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "form-component",
                "fieldId": "j765n4b",
                "properties": {
                  "styles": {
                    "margin": "0",
                    "justifyContent": "center",
                    "--backgroundColor": "#E9F3F1"
                  },
                  "grid": {
                    "alignItems": "center",
                    "columns": "0",
                    "justifyContent": "center"
                  },
                  "requires": [
                    "1"
                  ],
                  "successAction": {
                    "fn": "goToPage",
                    "params": "Elmex-MB2023/WinnerThankYou"
                  },
                  "endpoint": "/winnerRegister",
                  "fields": [
                    {
                      "fieldId": "b4baqs",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "surname",
                        "autocomplete": "no",
                        "label": "Prenume",
                        "placeholder": "",
                        "text": "",
                        "color": "#0E1B17",
                        "validation": "required|onlyLetters",
                        "grid": {
                          "alignItems": "center",
                          "justifyContent": "center",
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "30px",
                          "border-color": "#ADB5BD"
                        }
                      }
                    },
                    {
                      "fieldId": "gofije",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "name",
                        "autocomplete": "no",
                        "label": "Nume",
                        "placeholder": "",
                        "text": "",
                        "color": "#0E1B17",
                        "validation": "required|onlyLetters",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#ADB5BD"
                        }
                      }
                    },
                    {
                      "fieldId": "h7kzf9",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "email",
                        "label": "E-mail",
                        "placeholder": "",
                        "text": "",
                        "color": "#0E1B17",
                        "validation": "required|email",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#ADB5BD"
                        }
                      }
                    },
                    {
                      "fieldId": "vake42c",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "mobile",
                        "label": "Numar de telefon",
                        "placeholder": "",
                        "text": "",
                        "color": "#0E1B17",
                        "validation": "required|phoneNumber",
                        "grid": {
                          "columns": 12
                        },
                        "autocomplete": "nope",
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#ADB5BD"
                        }
                      }
                    },
                    {
                      "fieldId": "h7kzf8",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "address",
                        "label": "Adresa",
                        "placeholder": "",
                        "text": "",
                        "color": "#0E1B17",
                        "validation": "requiredAdress|adress",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#ADB5BD"
                        }
                      }
                    },
                    {
                      "fieldId": "ko3h1sz",
                      "fieldType": "paragraph",
                      "properties": {
                        "text": "*strada, numar, bloc, scara, apartament",
                        "grid": {
                          "columns": "12",
                          "marginTop": "20px;",
                          "marginBottom": "20px"
                        },
                        "classes": ['disclaimer'],
                        "styles":{
                          "color": "#00291C !important"
                        }
                      }
                    }
                  ],
                  "extraFields": [
                    {
                      "fieldId": "bdsb632",
                      "fieldType": "select-input-county",
                      "properties": {
                        "name": "judet",
                        "label": "Judet",
                        "placeholder": "Judet",
                        "text": "",
                        "color": "#0E1B17",
                        "validation": "requiredJudet",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "30px",
                          "border-color": "#ADB5BD"
                        },
                        "autocomplete": "nope"
                      }
                    },
                    {
                      "fieldId": "bask257",
                      "fieldType": "select-input-city",
                      "properties": {
                        "name": "localitate",
                        "label": "Localitate",
                        "placeholder": "Localitate",
                        "text": "",
                        "color": "#0E1B17",
                        "validation": "requiredLocal",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#ADB5BD"
                        },
                        "autocomplete": "nope"
                      }
                    },
                    {
                      "fieldId": "acasg235",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "postal",
                        "label": "Cod postal",
                        "placeholder": "",
                        "text": "",
                        "color": "#0E1B17",
                        "validation": "integer|length:6",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#ADB5BD"
                        },
                        "autocomplete": "nope",
                        "disablePaste": true
                      }
                    },
                    {
                      "fieldId": "bsdy4362",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "cnp",
                        "autocomplete": "no",
                        "label": "CNP",
                        "placeholder": "",
                        "text": "",
                        "validation": "required|integer|length:13",
                        "color": "#0E1B17",
                        "grid": {
                          "alignItems": "center;",
                          "justifyContent": "center;",
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#ADB5BD"
                        }
                      }
                    },
                    {
                      "fieldId": "bsadbsd325",
                      "fieldType": "checkbox",
                      "properties": {
                        "name": "cnpConfirm",
                        "validation": {
                          "required": {
                            "allowFalse": false
                          }
                        },
                        "validationName": "terms",
                        "grid": {
                          "columns": "12",
                          "paddingTop": "10px"
                        },
                        "styles": {
                          "margin-top": "30px",
                          "--color": "#00291C",
                          "--checkedCheckbox": "url(/assets/icons/form/checked_checkbox.svg)",
                          "--uncheckedCheckbox": "url(/assets/icons/form/unchecked_checkbox.svg)"
                        },
                        "label": `Declar ca acest CNP imi apartine, cunoscand faptul ca orice declaratie falsa este sanctionata conform legii penale romane.`
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            "sectionId": "yh453gg4",
            "grid": {
              "columns": 12,
              "display": "flex",
              "alignItems": "center",
              "position": "relative",
              "paddingTop": "60px",
              "paddingBottom": "130px"
            },
            "container": true,
            "styles": {
              'justify-content': 'center'
            },
            "fields": [
              {
                "fieldType": "button-component",
                "fieldId": "16tzm2",
                "properties": {
                  "grid": {
                    "columns": "0",
                    "alignItems": "center",
                    "justifyContent": "center"
                  },
                  "text": "TRIMITE",
                  "disabled": false,
                  "addClass": "btn-elmex-green-gradient",
                  "action": {
                    "fn": "sendForm",
                    "params": "j765n4b"
                  }
                }
              }
            ]
          }
        ]
      },
      { // Winner thank you
        "pageName": "Elmex-MB2023/WinnerThankYou",
        "pageId": 99830,
        "noContainer": true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "thank-you-winner",
                "fieldId": "gjd10",
                "properties": {
                  "campaign": "Elmex-MB2023",
                  "campaignName": "ELMEX®- MONEY BACK",
                  "haveActivator": false,
                  "textColor": "#0E1B17"
                }
              }
            ]
          }
        ]
      },
      { // Receipt reupload
        "pageName": "Elmex-MB2023/receipt-reupload",
        "isPublic": true,
        "pageId": 32,
        "sections": [
          {
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "headerWrap": true,
            "sectionId": "fu30zq",
            "fields": [
              {
                "fieldType": "query-string-to-state",
                "fieldId": "uwxo2o1",
                properties: {
                  variables: [
                    {
                      query: "referenceNumber",
                      state: "formData"
                    }
                  ]
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "<h1>Te rugam sa incarci din nou bonul fiscal/factura</h1>",
                  styles:{
                      "color": "#0E1B17"
                  }
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "Bonul fiscal/factura incarcat/a anterior nu ne este complet/a sau este ilizibil.",
                  "grid": {
                    "marginTop": "15px",
                    "marginBottom": "30px"
                  },
                  styles: {
                    "font-weight": '500;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '20px;',
                    "color": "#00291C;"
                  }
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "basg325",
                "properties": {
                  "text": "Te rugam sa faci o poza a intregului/intregii bon fiscal/facturi sau sa incarci un PDF al bonului fiscal/facturii",
                  "grid": {
                    "marginBottom": "40px"
                  },
                  styles: {
                    "font-weight": '400;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '14px;',
                    "line-height": "20px;",
                    "color": "#00291C;"
                  }
                }
              }
            ]
          },
          {
            "sectionId": "dyx8uv",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 0,
                    "justifyContent": "center",
                    "maxWidth": "1230px"
                  },
                  "fields": [
                    {
                      "fieldType": "receipt-processor",
                      "fieldId": "klvakj",
                      "properties": {
                        texts: {
                          choose: 'Selecteaza un fisier',
                          receiptUpload: '<span style="font-size:18px; font-weight: 500;font-family:Plus Jakarta Sans">Apasa aici pentru a incarca bonul fiscal/factura.</span>.<br> Doar fisierele JPEG, PNG si PDF sunt acceptate.<br> Maxim 16 MB.',
                          wrongFormat: 'Acest format nu este suportat. Doar fisiere jpeg, png sau pdf sunt acceptate.',
                          fileSizeLimit: 'Fisierul este prea mare. Acesta nu poate avea mai mult de 16 MB.'
                        },
                        "colorSchema": "#00B098",
                        "fileUploadColor": "rgba(0, 0, 0, 0.5)",
                        "borderColor": "#0A8870",
                        "buttonClass": "btn-elmex-green-secondary",
                        "inputBacgroundColor":"#E9F3F1",
                        "grid": {
                          "columns": 5,
                          "alignItems": "center",
                          "justifyContent": "center"
                        },
                        "successAction": {
                          "fn": "goToPage",
                          "params": "Elmex-MB2023/Multumesc"
                        },
                        "campaignId": "elmex-moneyback-2023",
                        "phrases": [
                          "Chitanta dvs. este acum incarcata si procesata.",
                          "Chitanta va fi procesata automat. Aceasta poate dura un minut. Va rugam sa aveti rabdare.",
                          "Daca primiti un mesaj de eroare, luati o versiune mai buna a chitantei si incarcati-o din nou."
                        ],
                        "cornerDetectionPhrases": [
                          "Te rugam sa ajustezi dreptunghiul gri pentru a incadra bonul.",
                          "Te rugam sa potrivesti bonul in cadran.",
                          "Puteti sterge informatii private cu instrumentul de stergere."
                        ],
                        "eraseColor": "#ffffff",
                        "eraseSize": 12,
                        "cropColor": "#F27B26",
                        "cropBackground": "rgba(0,0,0,0.6)",
                        "cropTitle": "Decupeaza",
                        "eraseTitle": "Acopera",
                        "dragTitle": "Deplaseaza imaginea",
                        "zoomInTitle": "Mareste",
                        "zoomOutTitle": "Micsoreaza",
                        "selectImageTitle": "Select an Image",
                        "selectAnotherTitle": "Select Another",
                        "controlsBackground": "#6B3050",
                        "backgroundColorBtn": "black",
                        "reUpload": true,
                        "tokenName": "token"
                      }
                    },
                    {
                      "fieldType": "empty-bucket",
                      "properties": {
                        "grid": {
                          "columns": 7
                        },
                        "fields": [
                          {
                            "fieldType": "receipt-information",
                            "fieldId": "5mq1p6",
                            "properties": {
                              "grid": {
                                "alignItems": "center",
                                "justifyContent": "center",
                                "columns": "12"
                              },
                              "styles": {
                                "text-align": "left"
                              },
                              "color": "#6B3050",
                              "textColor": "#0E1B17",
                              "descriptionTextColor":"#00291C",
                              "descriptionText": "Nu se accepta bonuri sau facturi pliate/indoite sau scanate",
                              "receiptImage": "receipt28",
                              "steps": [
                                {
                                  "text": "Nume magazin",
                                  "label": "A"
                                },
                                {
                                  "text": "Produsele participante la promotie si pretul lor",
                                  "label": "B"
                                },
                                {
                                  "text": "Suma totala a bonului/facturii in LEI/RON",
                                  "label": "C"
                                },
                                {
                                  "text": "Data si ora de pe bon sau de pe factura",
                                  "label": "D"
                                },
                                {
                                  "text": "Nr bonului fiscal/facturii",
                                  "label": "E"
                                }
                              ]
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            "sectionId": "bsbsd35",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "receipt-image-information"
              }
            ]
          },
          {
            "sectionId": "hmgwhl",
            "grid": {
              "columns": 12,
              "display": "flex",
              "alignItems": "center",
              "position": "relative",
              "paddingTop": "60px",
              "paddingBottom": "40px"
            },
            "container": true,
            "styles": {
              'justify-content': 'center'
            },
            "fields": [
              {
                "fieldType": "button-component",
                "fieldId": "16tzm2",
                "properties": {
                  "grid": {
                    "columns": "0",
                    "alignItems": "center",
                    "justifyContent": "center"
                  },
                  "text": "Trimite",
                  "addClass": "btn-elmex-green-gradient",
                  "shouldCheckCrop": true,
                  "requires": ["klvakj"],
                  "action": {
                    "fn": "sendReceipt",
                    "params": ""
                  }
                }
              }
            ]
          }
        ]
      },
      { // Product reupload
        "pageName": "Elmex-MB2023/product-reupload",
        "isPublic": true,
        "pageId": 1282452,
        "sections": [
          {
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "headerWrap": true,
            "sectionId": "fu30zq",
            "fields": [
              {
                "fieldType": "query-string-to-state",
                "fieldId": "uwxo2o1",
                properties: {
                  variables: [
                    {
                      query: "referenceNumber",
                      state: "formData"
                    }
                  ]
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "<h1>Incarca o poza a produsului</h1>",
                  styles: {
                    "color": "#0E1B17"
                  }
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "basv352",
                "properties": {
                  "text": "Incarca o poza cu produsele participante in campanie",
                  "grid": {
                    "marginTop": "15px",
                    "marginBottom": "30px"
                  },
                  styles: {
                    "font-weight": '500;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '20px;',
                    "color": "#00291C;"
                  }
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "basg325",
                "properties": {
                  "text": "Doar fisiere JPG, si PNG sunt acceptate. Fisierul poate avea maxim 16MB.",
                  "grid": {
                    "marginBottom": "40px"
                  },
                  styles: {
                    "font-weight": '400;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '14px;',
                    "line-height": "20px;",
                    "color": "#00291C;"
                  }
                }
              }
            ]
          },
          {
            "sectionId": "dyx8uv",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 0,
                    "justifyContent": "center",
                    "maxWidth": "1230px"
                  },
                  "fields": [
                    {
                      "fieldType": "product-upload",
                      "fieldId": "ase123v",
                      "properties": {
                        texts: {
                          choose: 'Selecteaza un fisier',
                          receiptUpload: '<span style="font-size:18px; font-weight: 500;font-family:Plus Jakarta Sans">Apasa aici pentru a incarca poza</span><br> Doar fisierele JPEG, PNG si PDF sunt acceptate.<br> Fisierul poate avea maxim 16 MB.',
                          wrongFormat: 'Acest format nu este suportat. Doar fisiere jpeg, png sau pdf sunt acceptate.',
                          fileSizeLimit: 'Fisierul este prea mare. Acesta nu poate avea mai mult de 16 MB.'
                        },
                        "colorSchema": "#00B098",
                        "borderColor": "#0A8870",
                        "buttonClass": "btn-elmex-green-secondary",
                        "inputBacgroundColor":"#E9F3F1",
                        "grid": {
                          "columns": 5,
                          "alignItems": "center",
                          "justifyContent": "center"
                        },
                        "endpoint": "/uploadProductPhoto",
                        "successAction": {
                          "fn": "goToPage",
                          "params": "Elmex-MB2023/Multumesc"
                        },
                        "phrases": [
                          "Chitanta dvs. este acum incarcata si procesata.",
                          "Chitanta va fi procesata automat. Aceasta poate dura un minut. Va rugam sa aveti rabdare.",
                          "Daca primiti un mesaj de eroare, luati o versiune mai buna a chitantei si incarcati-o din nou."
                        ],
                        "cornerDetectionPhrases": [
                          "Te rugam sa ajustezi dreptunghiul gri pentru a incadra bonul.",
                          "Te rugam sa potrivesti bonul in cadran.",
                          "Puteti sterge informatii private cu instrumentul de stergere."
                        ],
                        "reUpload": true
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            "sectionId": "hmgwhl",
            "grid": {
              "columns": 12,
              "display": "flex",
              "alignItems": "center",
              "position": "relative",
              "marginTop": "60px",
              "marginBottom": "30px"
            },
            "container": true,
            "styles": {
              'justify-content': 'center'
            },
            "fields": [
              {
                "fieldType": "button-component",
                "fieldId": "16tzm2",
                "properties": {
                  "grid": {
                    "columns": "0",
                    "alignItems": "center",
                    "justifyContent": "center"
                  },
                  "text": "Trimite",
                  "addClass": "btn-elmex-green-gradient",
                  "shouldCheckCrop": false,
                  "requires": ["ase123v"],
                  "action": {
                    "fn": "sendProductPhotos",
                    "params": ""
                  }
                }
              }
            ]
          }
        ]
      },
      { // Thank you
        "pageName": "Elmex-MB2023/Multumim",
        "pageId": 99800,
        "noContainer": true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "thank-you",
                "fieldId": "gjd10",
                "properties": {
                  "campaign": "Elmex-MB2023",
                  "campaignName": "ELMEX®- MONEY BACK",
                  "haveActivator": false,
                  "borderColor": "rgba(25, 91, 60, 0.25)",
                  "textColor": "#0E1B17",
                  "referenceColor": "#00B098"
                }
              }
            ]
          }
        ]
      },
      { // Thank you after reupload
        "pageName": "Elmex-MB2023/Multumesc",
        "pageId": 99801,
        "noContainer": true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "thank-you",
                "fieldId": "gjd10",
                "properties": {
                  "campaign": "Elmex-MB2023",
                  "campaignName": "ELMEX®- MONEY BACK",
                  "haveActivator": false,
                  "borderColor": "rgba(25, 91, 60, 0.25)",
                  "textColor": "#0E1B17",
                  "referenceColor": "#00B098"
                }
              }
            ]
          }
        ]
      },
      { // Error page
        "pageName": "error-page",
        "pageId": 10424,
        isPublic: true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 12
            },
            "container": true,
            fields: [
              {
                "fieldType": "error-page",
                "fieldId": "gjd10",
                "properties": {
                  "grid": {
                    "columns": "12"
                  }
                }
              }
            ]
          }
        ]
      },
      { // Faq
        "pageName": "Elmex-MB2023/IntrebariFrecvente",
        "isPublic": true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 12,
              "marginBottom": "50px"
            },
            "fields": [
              {
                "fieldType": "text-list",
                "fieldId": "a6prst",
                "properties": {
                  "colorSchema": "#2E2E2E",
                  "title": "Intrebari frecvente",
                  "items": [
                    { // 1
                      title: `Ce condițiitrebuie să îndeplinesc pentru a participa la Campania „NAȚIONALĂ ELMEX®- MONEY BACK”?`,
                      text: `
                      <ul>
                        <li>Vârsta minimă: Trebuie să ai cel puțin 18 ani.</li> 
                        <li>Domiciliul: Trebuie să ai domiciliul în România.</li> 
                        <li>Trebuie să ai un număr de telefon românesc.</li>  
                        <li>Detaliile contului: Trebuie să introduci un IBAN românesc.</li> 
                        <li>Adresa de e-mail: Poți participa doar cu propria adresă de e-mail.</li> 
                      </ul>
                      <div style="margin-top: 10px">Notă: IBAN-ul, numărul de telefon și adresa de e-mail pot fi combinate o singură dată pentru întreaga
                      perioadă a campaniei.</div>`
                    },
                    { // 2
                      title: `Cum pot participa la Campania „NAȚIONALĂ ELMEX®- MONEY BACK”?`,
                      text: `Poți participa doar online, prin intermediul site-ului campaniei <a href="/Elmex-MB2023" target="_blank">promocolgatepalmolive.ro</a>. Din păcate, nu este posibilă participarea prin poștă. Procesul poate fi descris după cum urmează:
                      <ul style="margin-top: 10px; margin-bottom: 10px">
                        <li>Fotografiază și încarcă bonul fiscal/factura;</li>
                      </ul>
                      Doar în cazul solicitării ulterioare, trebuie să încarci o fotografie a codului de
                      bare al produsului tău elmex®. (Trebuie să te asiguri că este vizibil codul de
                      bare.) În mod suplimentar, bonul fiscal/factura trebuie să apară clar/ă și
                      lizibil/ă pe fotografia cu produsul.
                      <ul style="margin-top: 10px;">
                        <li>Introdu adresa de e-mail și celelalte informații personale;</li>
                        <li>Acceptă termenii de participare și protecția datelor personale.</li>
                        <li>Vei primi un e-mail cu instrucțiuni privitoare la adresa unde trebuie să returnezi produsul.</li>
                        <li>Trimite produsul. De îndată ce vom primi produsul, vei fi informat prin e-mai și vei primi rambursul in termen de 4 săptămâni.</li>
                      </ul>
                      <div style="margin-top: 10px">Notă: Nu este posibilă utilizarea unor adrese de e-mail diferite (conturi de
                        utilizator) pentru aceeași persoană.</div>`
                    },
                    { // 3
                      title: `Pe cine trebuie să contactez dacă am o întrebare privitoare la Campania „NAȚIONALĂ ELMEX®- MONEY BACK”?`,
                      text: `Te rugăm să contactezi suportul campaniei la adresa <a href="mailto:suport@promocolgatepalmolive.ro">suport@promocolgatepalmolive.ro</a>`
                    },
                    { // 4
                      title: `Ce produse trebuie să cumpăr pentru a participa la Campania „NAȚIONALĂ ELMEX®-MONEY BACK”?`,
                      text: `Produsele următoare fac parte din Campania „NAȚIONALĂ ELMEX®- MONEYBACK”:
                      <ul>
                        <li>Pastă de dinți elmex Sensitive Professional 75ml (7610108047536)</li>
                        <li>Pastă de dinți elmex Sensitive Professional Gentle Whitening 75ml (7610108053568)</li>
                      </ul>
                      `
                    },
                    { // 5
                      title: `De unde pot cumpăra produsele participante la Campania „NAȚIONALĂ ELMEX®- MONEY BACK”?`,
                      text: `Poți cumpăra toate produsele participante la campanie din din toate farmaciile înregistrate din România.`
                    },
                    { // 6
                      title: `Dacă am folosit un voucher sau am beneficiat de reduceri suplimentare din valoarea produselor, ce ramburs voi primi?`,
                      text: `Orice reducere aplicată produselor participante sau utilizarea voucherelor de cumpărături, care este
                      marcată pe bonul fiscal/factură, va fi scăzută din suma totala rambursată. Reducerile sau voucherele nu pot
                      fi rambursate sub nicio formă printr-o sumă de bani.`
                    },
                    { // 7
                      title: `Când și unde trebuie să returnez produsul?`,
                      text: `Imediat ce primești e-mail-ul de confirmare, poțitrimite produsul în maximum 5 zile la adresa ce îți va fi
                      transmisă în e-mail de confirmare.`
                    },
                    { // 8
                      title: 'Care este suma rambursată?',
                      text: `Vei primi un ramburs de 100% din prețul efectiv plătit pentru produsul participant pe care dorești să-l
                      returnezi.`
                    },
                    { // 9
                      title: `Când pot participa la Campania „NAȚIONALĂ ELMEX®- MONEY BACK”?`,
                      text: `Perioada de achiziție a produsului promoțional este cuprinsă între 01.03.2023 și, inclusiv, 31.05.2023.
                      Înregistrarea pentru participarea la campania trebuie realizată în termen de 20 de zile după achiziționarea.
                      Termenul-limită pentru trimiterea formularului de înregistrare online și încărcarea bonului fiscal/facturii de
                      achiziție este 31.05.2023. După ce vei primi e-mailul de confirmare,trebuie să returnezi produsul în termen
                      de 5 zile.`
                    },
                    { // 10
                      title: 'Cât de des pot participa la Campania „NAȚIONALĂ ELMEX®- MONEY BACK”?',
                      text: `Fiecare persoană (cont de utilizator: IBAN și adresă de e-mail) poate participa la campanie cu un număr
                      maxim de 1 ori.`
                    },
                    { // 11
                      title: 'Cu câte produse pot participa la Campania „NAȚIONALĂ ELMEX®- MONEYBACK”?',
                      text: `Rambursările pot fi eliberate pentru un produs participant per persoană.`
                    },
                    { // 12
                      title: 'Eu și partenerul/a meu/a avem un contIBAN comun. Putem participa amândoi la Campania „NAȚIONALĂ ELMEX®- MONEYBACK” cu acest contîn mod separat?',
                      text: `Fiecare IBAN poate fi folosit de către un singur utilizator pentru întreaga perioadă promoțională (într-o
                        combinație fixă cu adresa de e-mail și numărul de telefon). Utilizarea în comun cu alt participant nu este
                        posibilă, indiferent de orice legătură personală.`
                    },
                    { // 13
                      title: 'Când mă pot aștepta la ramburs?',
                      text: `După recepționarea produsuluitrimis de către tine, suma rambursată va fi transferată în contultău bancar
                      (IBAN) menționatîn maxim 4 săptămâni.`
                    },
                    { // 14
                      title: 'Cine va fi responsabil pentru orice costuri legate de transferul rambursului?',
                      text: `Pentru Campania „NAȚIONALĂ ELMEX®- MONEYBACK”, organizatorul nu este responsabil de niciun cost
                      asociat cu transferul rambursului. Fiecare participanttrebuie să se informeze înainte de a participa la
                      campanie în ceea ce privește posibilele cheltuieli privitoare la ramburs. Fiecare bancă are posibilitatea de a
                      impune taxe în conformitate cu politicile sale interne, iar organizatorul Campaniei nu are control sau
                      informații despre aceste potențiale cheltuieli. Cheltuielile asociate cu transferul de bani pot varia de la o
                      bancă la alta. În cazultău, le poți găsi scrise în contractul încheiat cu banca și pe care l-ai semnat când ai
                      deschis contultău bancar cu IBAN.`
                    },
                    { // 15
                      title: 'Câttimp trebuie să păstrez bonul fiscal/factura?',
                      text: `Trebuie să păstrezi bonul fiscal/factura până în momentul în care primești rambursul.`
                    },
                    { // 16
                      title: 'Bonul meu fiscal conține mai mult de un produs promoțional elmex®. Pot două sau mai multe persoane să folosească bonul fiscal/factura?',
                      text: `În principiu, un bon fiscal/factură poate participa o singură dată la Campania „NAȚIONALĂ ELMEX®-
                      MONEYBACK”. Produsele promoționale enumerate pe bonul fiscal/factură nu pot fi luate în considerare, iar
                      un produs promoțional nu poate fi transferat altei persoane.`
                    },
                    { // 17
                      title: 'Nu am primit un e-mail de confirmare după terminarea procesului de înscriere. Ce trebuie să fac?',
                      text: `După ce te-ai înregistrat, vei primi un e-mail de confirmare cu un număr de referință format din 10 caractere alfanumerice. Te rugăm să verifici și dosarul de SPAM șiJUNK. Dacă nu ai primit un număr de referință format din 10 caractere alfanumerice,te rugăm să participi din nou prin intermediul site-ului pentru promoții
                      <a href='https://promocolgatepalmolive.ro/Elmex-MB2023.' target='_blank'>https://promocolgatepalmolive.ro/Elmex-MB2023.</a>`
                    },
                    { // 18
                      title: 'Când parcurg procesul de înscriere pentru rambursare, acesta se oprește la un moment dat. Ce trebuie să fac?',
                      text: `Dacă te încurci în timpul procesului de înscriere din motive tehnice, îți recomandăm – dacă este posibil – să
                      utilizezi un alt dispozitiv. De exemplu,treci de pe telefonul mobil pe calculator. Dacă acestlucru nu rezolvă
                      problema, poți încerca să folosești un alt browser. Dacă aceste sfaturi nu te ajută,te rugăm să trimiți un
                      e-mail departamentului nostru de suport <a href='suport@promocolgatepalmolive.ro' target='_blank'>suport@promocolgatepalmolive.ro</a>. Te rugăm să furnizezi o descriere precisă a problemei în e-mailultău – o captură de ecran cu pasul la care te blochezi este perfectă. Alte informații utile sunt dispozitivultău, sistemul de operare și browserul pe care le folosești. Echipa noastră de suport se va strădui să te ajute.`
                    },
                    { // 19
                      title: 'Din ce cauză IBAN-ul meu nu este acceptat pe pagina de promoție?',
                      text: `Asigură-te că introduci IBAN-ulfără spații. Te rugăm să introduci codulțării la început. De asemenea,
                      asigură-te că nu ai introdus în mod accidental un spațiu înainte sau după IBAN.`
                    },
                    { // 20
                      title: 'Nu este mai ușor să primesc rambursul pe cardul Revolut. Este disponibilă opțiunea?',
                      text: `Momentan, singura posibilitate de participare este să furnizezi un IBAN valid. Pentru activările ulterioare,
                      vom lua în considerare și sugestia ta.`
                    },
                    { // 21
                      title: 'Cum îmi pot da seama dacă am reușit să încarc bonul fiscal/factura?',
                      text: `După ce încarci bonul fiscal/factura și introduci informațiile personale, va apărea un mesaj pe ecran care
                      confirmă înscrierea participăriitale și îți afișează numărul personal de referință. Vei primi cu promptitudine și
                      un e-mail de confirmare sau respingere a participării pe adresa furnizată.`
                    },
                    { // 22
                      title: 'Câttimp este disponibil departamentul de suport?',
                      text: `Echipa noastră de suport este disponibilă de la începutul campanieitimp de 6 săptămâni după expirarea
                      datei de înregistrare. După 14.07.2023, datele tale vor fi șterse, departamentul de suport va fi închis, iar
                      întrebările tale nu vor mai fi tratate.`
                    },
                    { // 23
                      title: 'Participarea mea a fost confirmată, dar suma rambursată nu este corectă. Cum pot proceda?',
                      text: `În mesajul de confirmare, vei găsi un buton prin care poți solicita reevaluarea cazuluitău, dar care nu mai
                      este activ după 72 de ore. În acest caz,te rugăm să contactezi echipa noastră de suportla <a href='mailto:suport@promocolgatepalmolive.ro' target='_blank'>suport@promocolgatepalmolive.ro</a> și să descrii situația ta în e-mail. Echipa noastră îți va trata cazul.
                      `
                    },
                    { // 24
                      title: 'Câttimp am posibilitatea de a solicita reevaluarea cazului meu?',
                      text: `Poți solicita reprocesarea bonului fiscal/facturii dând clic pe butonul Reevaluare bon fiscal/factură. Reține
                      că butonulfuncționează doartimp de 72 de ore.
                      <br><br>
                      După aceea, singura modalitate în care îți putem reevalua cazul este prin contactarea echipei noastre de
                      suport. Te rugăm să incluzi întotdeauna numărultău de referință!
                      <br><br>
                      Această opțiune este disponibilă doar pentru o perioadă limitată de timp. Informațiile tale vor fi șterse după
                      expirarea campaniei de rambursare, așadar procesarea este posibilă numai până la 6 săptămâni după
                      termenul-limită, adică până pe 14.07.2023. După aceasta, departamentul de suport va fi închis, iar
                      solicitările tale nu vor mai putea fi tratate.`
                    },
                    { // 25
                      title: 'Bonul fiscal/factura mi-a fostrespins/ă deoarece nu suntlizibile toate informațiile. Ce informațiitrebuie să fie lizibile?',
                      text: `Magazinul, produsul promoțional elmex®, prețul de achiziție al produsului promoțional elmex®, valoarea
                      totală a bonului fiscal/facturii, numărul bonului fiscal/facturii, TVA-ul vizibil, orice reduceri care pot fi aplicate
                      și ora și data.`
                    },
                    { // 26
                      title: 'De ce mi-a fostrespinsă participarea, deși am cumpărat produsul participant?',
                      text: `
                      De exemplu, poate fi din cauza unei eroritehnice sau a faptului că bonul fiscal/factura nu este suficient de lizibil/ă sau este supraexpus/ă.
                      <br><br>
                      În partea de jos a e-mailului de respingere, vei găsi un buton pentru a încărca bonul fiscal/factura din nou.
                      Dă clic pe buton și vei fi redirecționat automat către încărcarea din nou a bonului fiscal/facturii. Te rugăm să
                      realizezi o fotografie nouă a bonului fiscal/facturii și s-o încarci din nou în termen de 72 de ore. Te rugăm să
                      reții că butonul nu mai este funcțional după 72 de ore
                      <br><br>
                      Dacă participarea ta este respinsă din nou,te rugăm să ne contactezi prin intermediul adresei de e-mail de
                      suport, care poate fi găsită și în e-mailul de respingere (<a href='suport@promocolgatepalmolive.ro' target='_blank'>suport@promocolgatepalmolive.ro</a>).
                      `
                    },
                    { // 27
                      title: 'Bonul meu fiscal/factura nu a fost acceptat/ă sau chiar a fost marcat/ă ca fals/ă. Cum este posibil așa ceva?',
                      text: `În cazul în care bonul fiscal/factura este prea neclar/ă sau prea întunecat/ă sau supraexpus/ă astfel, încât
                      informațiile nu mai pot fi lizibile, există posibilitatea să primești un e-mail de respingere, în care bonul
                      fiscal/factura este descris/ă drept un fals sau ești rugat să furnizezi o fotografie mai bună cu Încarcă bonul
                      fiscal/factura. Ajută-ne să îți acceptăm participarea rapid șifără complicații, încărcând o fotografie de
                      bună calitate (nu o scanare!) a bonuluitău, care demonstrează că ai un bon fiscal/factură original/ă și în care
                      suntlizibile toate informațiile necesare. Economisește multtimp și neplăceri atât pentru tine, cât și pentru
                      noi.`
                    },
                    { // 28
                      title: 'Pottrimite bonul fiscal/factura și prin e-mail?',
                      text: `Trimiterea ulterioară a bonului fiscal/facturii poate fi realizată prin butonul de reîncărcare, care se găsește în
                      e-mailul de respingere.
                      <br><br>
                      Dacă nu ai primit un e-mail de respingere sau de confirmare, atunci este un indiciu că nu ai reușit să te înscrii
                      sau trebuie să parcurgi din nou procesul de rambursare.`
                    },
                    { // 29
                      title: 'Am introdus IBAN-ul greșitla înregistrare. Ce se întâmplă în acest caz?',
                      text: `Dacă ai introdus un IBAN greșit, în care transferul nu poate fi realizat, singura posibilitate este de a-l
                      schimba. Poți contacta departamentul responsabil prin e-mail până pe 14.07.2023:
                      <a href='iban-suport@promocolgatepalmolive.ro target='_blank'>iban-suport@promocolgatepalmolive.ro</a> Dacă nu se poate realiza un transfer nici cu acestIBAN, dreptul la
                      ramburs expiră. Te rugăm să te asiguri că IBAN-ul nu a fost deja folosit pentru altramburs din Campania
                      „NAȚIONALĂ ELMEX®- MONEYBACK”.`
                    },
                    { // 30
                      title: 'Mi s-a solicitat să mă înscriu prin poștă. Ce înseamnă acestlucru?',
                      text: `
                      Te rugăm să înțelegi că suntem obligați să verificăm cu atenție toate bonurile fiscale/facturile cu privire la
                      autenticitatea lor. Desigur, există posibilitatea ca un bon fiscal/factură să fie respins/ă în mod greșit.
                      <br><br>
                      În acest caz, îți solicităm să trimiți bonul original către agenția responsabilă prin poștă. Ți se va oferi adresa
                      corespunzătoare prin e-mail. În cazul în care participarea ta este considerată validă, îți vom transfera atât
                      suma rambursată, cât șitaxele poștale. Pentru cele de mai sus și alte motive, prin urmare este necesar să
                      păstrezi bonul fiscal/factura până la creditarea rambursului în contultău.`
                    },
                    { // 31
                      title: 'Am o întrebare generală despre elmex®. Cu cine trebuie să vorbesc?',
                      text: `Dacă ai nevoie de informații suplimentare privitoare la produsele noastre sau dacă ai orice alte întrebări, ne
                      poți contacta prin intermediul linkului de mai jos: <a href='https://www.colgatepalmolive.ro/contact-us' target='_blank'>https://www.colgatepalmolive.ro/contact-us</a>`
                    }
                  ],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "8"
                  }
                }
              }
            ]
          }
        ]
      },
      { // Castigatori
        "pageName": "Elmex-MB2023/castigatori",
        "isPublic": true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 12,
              "marginBottom": "50px"
            },
            "fields": [
              {
                "fieldType": "text-list",
                "fieldId": "a6prst",
                "properties": {
                  "colorSchema": "#002923",
                  "title": "Castigatori",
                  "ordered": false,
                  "items": [
                    {
                    //   title: `Bicicleta Pegas`,
                    //   text: `
                    //   <ul>
                    //     <li>Neculcea	Florin</li>
                    //     <li>Banu	Marius Andrei</li>
                    //     <li>Soarice	Corneliu</li>
                    //   </ul>`
                    }
                  ],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "8"
                  }
                }
              }
            ]
          }
        ]
      }
    ],
    "header": {
      "fieldType": "navbar",
      "fieldId": "cbx34t",
      "properties": {
        "dataLayer": {
          "GTM": {
            "Sitelocale": "ro-ro",
            "SiteTouchpoint": "",
            "SiteCountry": "RO",
            "SiteBrand": "",
            "SiteLanguage": "RO",
            "SitePlatform": "",
            "SiteEnvironment": "Prod",
            "SiteHost": "CTL",
            "SiteTechnicalAgency": "Justsnap",
            "SiteStatus": "Live",
            "GoogleAnalyticsLocal": "UA-15274544-47",
            "GoogleAnalyticsBrand": "",
            "GoogleAnalyticsSiteSpeedSampleRate": "high",
            "GoogleAnalyticsAllowLinker": "true",
            "GoogleAnalyticsLinkerDomains": "",
            "GoogleAnalyticsEnableOptimizely": "false",
            "GoogleAnalyticsConsentRequired": "true",
            "GoogleAnalyticsOptimizeContainerID": "",
            "GoogleAnalyticsReportingView": "",
            "GoogleReCaptcha": "true",
            "SiteLocalContainer": "",
            "FacebookRemarketingID": "270266680523196",
            "ConsentOverlay": "OneTrust",
            "ConsentOverlayID": "htmllang/7bfbeeed-fe9a-477f-99c7-84ca45614eb3-test",
            "SitePrivacyProtection": "GDPR"
          },
          "GTM_CODE": "GTM-TG4C5LV"
        },
        // "neustar": {
        //   "url": "https://aa.agkn.com/adscores/g.js?sid=9212300878"
        // },
        // "facebookPixel": {
        //   init: "270266680523196"
        // },
        "title": "",
        "color": "#FAF6EE",
        "grid": {
          "columns": 12
        },
        "logo": {
          "imageSource": "/assets/logo.svg",
          "width": 345,
          "alternateText": "Brand Logo",
          "paddingTop": "30px"
        },
        "fields": [
          // {
          //   "fieldId": "bsdb35",
          //   "fieldType": "anchor",
          //   "properties": {
          //     "text": "Castigatori",
          //     "url": "/Elmex-MB2023/castigatori",
          //     "target": "_blank",
          //     "cssClass": "nav-link",
          //     "styles": {
          //       "color": "#050E23",
          //       "fontSize": "18px",
          //       "fontWeight": "400"
          //     }
          //   }
          // },
          {
            "fieldId": "ikz8vc",
            "fieldType": "anchor",
            "properties": {
              "text": "Regulament",
              "url": "/files/Elmex-MB2023Regulament.pdf",
              "target": "_blank",
              "cssClass": "nav-link",
              "styles": {
                "color": "#050E23",
                "fontSize": "18px",
                "fontWeight": "400"
              }
            }
          },
          {
            "fieldId": "slnmdk",
            "fieldType": "anchor",
            "properties": {
              "text": "Intrebari frecvente",
              "url": "/Elmex-MB2023/IntrebariFrecvente",
              "target": "_blank",
              "cssClass": "nav-link",
              "styles": {
                "color": "#050E23",
                "fontSize": "18px",
                "fontWeight": "400"
              }
            }
          }
        ],
        "showLine": false,
        "meta": [
          { "name": "title", "content": "Protex" },
          {
            "name": "description",
            "content": `Protex`
          },
          {
            "name": "keywords",
            "content": `Protex`
          }
        ]
      }
    },
    "footer": {
      "fieldType": "footer-component",
      "fieldId": "4tfbzz",
      "properties": {
        "links": [
          { "name": "", "link": "" }
        ],
        "supportLinks": [
          { "name": "Confidentialitate", "link": "https://www.jnjconsumer.ro/politica-confidentialitate" }
        ],
        "styles": {
          "color": "#000"
        },
        "fields": [
          {
            "fieldId": "ikz8vc1",
            "fieldType": "anchor",
            "properties": {
              "text": "Termeni si conditii",
              "url": "/files/Elmex-MB2023Regulament.pdf",
              "target": "_blank",
              "styles": {
                "color": "#40454A"
              }
            }
          },
          {
            "fieldId": "slnmdk2",
            "fieldType": "anchor",
            "properties": {
              "text": " Politica de confidentialitate",
              "url": "https://www.colgatepalmolive.ro/legal-privacy-policy/privacy-policy",
              "target": "_blank",
              "styles": {
                "color": "#40454A"
              }
            }
          }
        ]
      }
    },
    "campaignId": "elmex-moneyback-2023",
    "url": "https://promocolgatepalmolive.ro/",
    "name": "elmex-moneyback-2023"
  },
  pageBuilder: {
    selectedField: {
      sectionId: '',
      fieldId: generateUID()
    }
  },
  componentStatus: {},
  modal: {
    type: 'error',
    message: 'An error has occurred',
    isActive: false
  },
  customerToken: '',
  receiptToken: '',
  receiptImage: '',
  campaignId: 'elmex-moneyback-2023',
  formData: new FormData(),
  campaignStartDate: "2023-03-01",
  campaignEndDate: "2023-05-31",
  showNavLinks: false,
  excludedPages: ['home'],
  cities: []
}
